import { capturePostHogEvent } from './posthog';

const { ENVIRONMENT } = process.env;

const commonProps = {
  // environment: ENVIRONMENT,
  // LOG_DATE: Date.now()
}

// Invite / OTP Login Events
// These cover the unauthenticated entry point (/assessment/start/:inviteToken →
// email → OTP → runner). Never put the invite token or the OTP code in a
// property — they are credentials.
export const trackInviteLinkOpened = (assessmentType, inviteStatus, role, company) => {
  capturePostHogEvent('invite_link_opened', {
    assessment_type: assessmentType,
    invite_status: inviteStatus, // 'new' | 'already_attempted'
    role: role,
    company: company,
    ...commonProps
  });
};

export const trackInviteLinkInvalid = (reason) => {
  capturePostHogEvent('invite_link_invalid', {
    reason: reason,
    ...commonProps
  });
};

export const trackInviteOtpRequested = (assessmentType, isResend, role, company) => {
  capturePostHogEvent('invite_otp_requested', {
    assessment_type: assessmentType,
    is_resend: isResend,
    role: role,
    company: company,
    ...commonProps
  });
};

export const trackInviteOtpRequestFailed = (assessmentType, isResend, reason) => {
  capturePostHogEvent('invite_otp_request_failed', {
    assessment_type: assessmentType,
    is_resend: isResend,
    reason: reason,
    ...commonProps
  });
};

export const trackInviteOtpVerified = (assessmentAssignId, assessmentType, role, company) => {
  capturePostHogEvent('invite_otp_verified', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    role: role,
    company: company,
    ...commonProps
  });
};

export const trackInviteOtpVerificationFailed = (assessmentType, reason) => {
  capturePostHogEvent('invite_otp_verification_failed', {
    assessment_type: assessmentType,
    reason: reason,
    ...commonProps
  });
};

// Assessment Lifecycle Events
export const trackAssessmentEntered = (assessmentAssignId, assessmentType, isCorporate, entityName) => {
  capturePostHogEvent('assessment_entered', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    isCorporate: isCorporate,
    entityName: entityName,
    entered_time: Date.now(),
    ...commonProps
  });
};

export const trackAssessmentStarted = (assessmentAssignId, assessmentType, isCorporate, entityName) => {
  capturePostHogEvent('assessment_started', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    isCorporate: isCorporate,
    entityName: entityName,
    start_time: Date.now(),
    ...commonProps
  });
};

export const trackAssessmentCompleted = (totalTimeSeconds, assessmentAssignId, assessmentType, isCorporate, entityName) => {
  capturePostHogEvent('assessment_completed', {
    total_time_seconds: totalTimeSeconds,
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackAssessmentDroppedOff = (timeElapsedSeconds, assessmentAssignId, assessmentType, isCorporate, entityName) => {
  capturePostHogEvent('assessment_droppedoff', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    time_elapsed_seconds: timeElapsedSeconds,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackAssessmentAutoSubmitted = (assessmentAssignId,violationCount, reason, assessmentType, isCorporate, entityName) => {
  capturePostHogEvent('assessment_auto_submitted', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    violation_count: violationCount,
    reason: reason,
    isCorporate: isCorporate,
    entityName: entityName,
    auto_submit_time: Date.now(),
    ...commonProps
  });
};

// Question Events
export const trackQuestionViewed = (questionId, questionType, questionNumber, totalQuestions, assessmentAssignId, assessmentType, isCorporate, entityName) => {
  capturePostHogEvent('assessment_question_viewed', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    question_id: questionId,
    question_type: questionType,
    question_number: questionNumber,
    total_questions: totalQuestions,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackQuestionAnswered = (assessmentAssignId, assessmentType, questionId, questionType, answerValue, timeSpentSeconds, isCorporate, entityName) => {
  capturePostHogEvent('assessment_question_answered', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    question_id: questionId,
    question_type: questionType,
    answer_value: answerValue,
    time_spent_seconds: timeSpentSeconds,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackQuestionSkipped = (assessmentAssignId, assessmentType, questionId, questionType, questionNumber, isCorporate, entityName) => {
  capturePostHogEvent('assessment_question_skipped', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    question_id: questionId,
    question_type: questionType,
    question_number: questionNumber,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackAnswerChanged = (assessmentAssignId, assessmentType, questionId, oldAnswer, newAnswer, changeCount, isCorporate, entityName) => {
  capturePostHogEvent('assessment_answer_changed', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    question_id: questionId,
    old_answer: oldAnswer,
    new_answer: newAnswer,
    change_count: changeCount,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

// Navigation Events
export const trackNextQuestion = (assessmentAssignId, assessmentType, currentQuestion, nextQuestion, isCorporate, entityName) => {
  capturePostHogEvent('assessment_next_question', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    current_question: currentQuestion,
    next_question: nextQuestion,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackPreviousQuestion = (assessmentAssignId, assessmentType, currentQuestion, previousQuestion, isCorporate, entityName) => {
  capturePostHogEvent('assessment_previous_question', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    current_question: currentQuestion,
    previous_question: previousQuestion,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackQuestionNavigationUsed = (assessmentAssignId, assessmentType, fromQuestion, toQuestion, isCorporate, entityName) => {
  capturePostHogEvent('assessment_question_navigation_used', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    from_question: fromQuestion,
    to_question: toQuestion,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackSectionChanged = (assessmentAssignId, assessmentType, fromSection, toSection, sectionType, isCorporate, entityName) => {
  capturePostHogEvent('assessment_section_changed', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    from_section: fromSection,
    to_section: toSection,
    section_type: sectionType,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

// Diagnosis Events
export const trackDiagnosisStarted = (diagnosisNumber, assessmentAssignedId, assessmentType, entityName) => {
  console.log("Tracking diagnosis started");
  capturePostHogEvent('assessment_diagnosis_started', {
    diagnosis_number: diagnosisNumber,
    assessment_assigned_id: assessmentAssignedId,
    assessment_type: assessmentType,  
    entityName: entityName,
    started_time: Date.now(),
    ...commonProps
  });
};

export const trackDiagnosisCompleted = (diagnosisNumber, score, timeTakenSeconds, assessmentAssignedId, assessmentType, entityName) => {
  capturePostHogEvent('assessment_diagnosis_completed', {
    diagnosis_number: diagnosisNumber,
    score: score,
    time_taken_seconds: timeTakenSeconds,
    assessment_assigned_id: assessmentAssignedId,
    assessment_type: assessmentType,
    entityName: entityName,
    ...commonProps
  });
};

export const trackDiagnosisDroppedOff = (diagnosisNumber, timeElapsedSeconds, assessmentAssignedId, assessmentType, entityName) => {
  capturePostHogEvent('assessment_diagnosis_droppedoff', {
    diagnosis_number: diagnosisNumber,
    time_elapsed_seconds: timeElapsedSeconds,
    assessment_assigned_id: assessmentAssignedId,
    assessment_type: assessmentType,
    entityName: entityName,
    ...commonProps
  });
};

export const trackDiagnosisProgressUpdated = (assessmentAssignId, assessmentType, completedCount, requiredCount, entityName) => {
  capturePostHogEvent('assessment_diagnosis_progress_updated', {
    assessment_assigned_id: assessmentAssignId,
    assessment_type: assessmentType,
    completed_count: completedCount,
    required_count: requiredCount,
    entityName: entityName,
    ...commonProps
  });
};

export const trackPracticeUnlocked = (assessmentType) => {
  capturePostHogEvent('assessment_practice_unlocked', {
    unlock_date: Date.now().toString().split(" ")[0],
    assessment_type: assessmentType,
    ...commonProps
  });
};

// Practice Events
export const trackPracticeTabViewed = (practiceUnlocked, diagnosisCompleted, assessmentType) => {
  capturePostHogEvent('assessment_practice_tab_viewed', {
    practice_unlocked: practiceUnlocked,
    diagnosis_completed: diagnosisCompleted,
    assessment_type: assessmentType,  
    ...commonProps
  });
};

export const trackPracticeLockedClicked = (diagnosisCompleted, assessmentType) => {
  capturePostHogEvent('assessment_practice_locked_clicked', {
    diagnosis_completed: diagnosisCompleted,
    assessment_type: assessmentType,
    ...commonProps
  });
};

export const trackPracticeSessionStarted = (assessmentAssignId, assessmentTopics, assessmentType, mode, isCorporate, entityName) => {
  capturePostHogEvent('assessment_practice_session_started', {
    assessment_assign_id: assessmentAssignId,
    assessment_topics: assessmentTopics,
    assessment_type: assessmentType,
    mode: mode, // 'AI' or 'manual'
    isCorporate: isCorporate,
    entityName: entityName,
    started_time: Date.now(),
    ...commonProps
  });
};

export const trackPracticeQuestionAttempted = (assessmentAssignId, assessmentType, questionId, questionType, attemptNumber, isCorporate, entityName) => {
  capturePostHogEvent('assessment_practice_question_attempted', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    question_id: questionId,
    question_type: questionType,
    attempt_number: attemptNumber,
    isCorporate: isCorporate,
    entityName: entityName,
    started_time: Date.now(),
    ...commonProps
  });
};

export const trackPracticeAnswerSubmitted = (assessmentAssignId, assessmentType, questionId, answerCorrect, timeSpentSeconds, isCorporate, entityName) => {
  capturePostHogEvent('assessment_practice_answer_submitted', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    question_id: questionId,
    answer_correct: answerCorrect,
    time_spent_seconds: timeSpentSeconds,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackPracticeSessionCompleted = (assessmentAssignId, assessmentType, timeSpentSeconds) => {
  capturePostHogEvent('assessment_practice_session_completed', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    time_spent_seconds: timeSpentSeconds,
    ...commonProps
  });
};

export const trackPracticeSessionDroppedOff = (assessmentAssignId, assessmentType, questionsAttempted, timeElapsedSeconds, isCorporate, entityName) => {
  capturePostHogEvent('assessment_practice_session_dropedoff', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    questions_attempted: questionsAttempted,
    time_elapsed_seconds: timeElapsedSeconds,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

// Proctoring Events
export const trackFullscreenEntered = (assessmentAssignId, assessmentType, afterViolation = false, isCorporate, entityName) => {
  capturePostHogEvent('assessment_fullscreen_entered', {
    assessment_assign_id: assessmentAssignId, // Note: keeping CSV spelling
    assessment_type: assessmentType,
    after_voilation: afterViolation,
    time: Date.now(),
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackFullscreenExited = (assessmentAssignId, assessmentType, violationCount, isCorporate, entityName) => {
  capturePostHogEvent('assessment_fullscreen_exited', {
    assessment_assign_id: assessmentAssignId,
    assessment_type: assessmentType,
    violation_count: violationCount,
    time: Date.now(),
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackViolationDetected = (assessment_assign_id, assessment_type,violationCount, violationType, isCorporate, entityName) => {
  capturePostHogEvent('assessment_violation_detected', {
    assessment_assign_id: assessment_assign_id,
    assessment_type: assessment_type,
    violation_count: violationCount,
    voilation_type: violationType,
    time: Date.now(),
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackCopyPasteAttempted = (assessmentAssignId, assessmentType, content, isCorporate, entityName) => {
  capturePostHogEvent('assessment_copy_paste_attempted', {
    assessment_assign_id: assessmentAssignId, // Note: keeping CSV spelling
    assessment_type: assessmentType,
    content: content,
    time: Date.now(),
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};

export const trackRightClick = (assessmentAssignId, assessmentType, isCorporate, entityName) => {
  capturePostHogEvent('assessment_right_click', {
    assessment_assign_id: assessmentAssignId, // Note: keeping CSV spelling
    assessment_type: assessmentType,
    isCorporate: isCorporate,
    entityName: entityName,
    ...commonProps
  });
};